var map = {
	"./Aboutus/Image_1.png": 5203,
	"./BlogImage/2.png": 7294,
	"./BlogImage/4.png": 7672,
	"./BlogImage/blog01.png": 8047,
	"./BlogImage/blog02.jpg": 7360,
	"./BlogImage/blog03.png": 9693,
	"./BlogImage/blog04.png": 7186,
	"./BlogImage/blog05.png": 5051,
	"./BlogImage/blog06.png": 3072,
	"./BlogImage/blog07.png": 7897,
	"./BlogImage/blog08.png": 8990,
	"./BlogImage/blog09.png": 7303,
	"./BlogImage/blog1.png": 2981,
	"./BlogImage/blogImage2.png": 6669,
	"./BlogImage/blogImage3.png": 3636,
	"./Button/Music Library.png": 6485,
	"./Button/Picture.png": 7631,
	"./Button/landingPage_checked_icon.png": 5771,
	"./Button/landingPage_user_icon.png.png": 6016,
	"./Button/landingPage_vector_icon.png": 3423,
	"./Button/presentation.png": 3829,
	"./Button/settings.png": 482,
	"./Button/videoIcon.png": 3899,
	"./DeleteIcon.png": 1850,
	"./FLOW.gif": 6351,
	"./File_Icon/pdf_icon.png": 2955,
	"./File_Icon/xlsx_icon.png": 2882,
	"./File_Icon/youtube_icon.png": 9216,
	"./LandingPage_Items/1_image.png": 8625,
	"./LandingPage_Items/2_Video.png": 828,
	"./LandingPage_Items/3_audio.png": 9298,
	"./LandingPage_Items/4_Presentation.png": 6919,
	"./LandingPage_Items/5_Blog.png": 1968,
	"./LandingPage_Items/Actionable_Image.png": 5232,
	"./LandingPage_Items/CaseStudies/Logo.png": 3043,
	"./LandingPage_Items/CaseStudies/UpArrow_Icon.png": 8440,
	"./LandingPage_Items/CaseStudies/casestudy01.png": 2894,
	"./LandingPage_Items/CaseStudies/casestudy02.png": 3253,
	"./LandingPage_Items/CaseStudies/casestudy03.png": 364,
	"./LandingPage_Items/How It Works/Checked.png": 9969,
	"./LandingPage_Items/How It Works/Search_User.png": 7932,
	"./LandingPage_Items/How It Works/User_Edit.png": 2378,
	"./LandingPage_Items/How It Works/how_works_image_below_990.png": 6992,
	"./LandingPage_Items/How It Works/video output Image for How it works.png": 1243,
	"./LandingPage_Items/ImageGallery/imageGallery01.png": 1026,
	"./LandingPage_Items/ImageGallery/imageGallery02.png": 1737,
	"./LandingPage_Items/ImageGallery/imageGallery03.png": 6912,
	"./LandingPage_Items/ImageGallery/imageGallery04.png": 8239,
	"./LandingPage_Items/ImageGallery/imageGallery05.png": 1910,
	"./LandingPage_Items/ImageGallery/imageGallery06.png": 3533,
	"./LandingPage_Items/ImageGallery/imageGallery07.png": 3588,
	"./LandingPage_Items/ImageGallery/imageGallery08.png": 1251,
	"./LandingPage_Items/ImageGallery/imageGallery09.png": 3674,
	"./LandingPage_Items/Landingpage_Modalx_FlowDiagram.png": 5672,
	"./LandingPage_Items/Landingpage_Modalx_FlowDiagram_below_990.png": 6989,
	"./LandingPage_Items/Logo_1.png": 429,
	"./LandingPage_Items/Logo_2.png": 9222,
	"./LandingPage_Items/Logo_3.png": 620,
	"./LandingPage_Items/Logo_4.png": 2368,
	"./LandingPage_Items/Logo_5.png": 8617,
	"./LandingPage_Items/Logo_6.png": 2530,
	"./LandingPage_Items/Logo_7.png": 3659,
	"./LandingPage_Items/ModalxInAction_Icons/Image1.png": 6034,
	"./LandingPage_Items/ModalxInAction_Icons/Image2.png": 1177,
	"./LandingPage_Items/ModalxInAction_Icons/Image3.png": 6352,
	"./LandingPage_Items/ModalxInAction_Icons/Image4.png": 5007,
	"./LandingPage_Items/ModalxInAction_Icons/Image5.png": 6918,
	"./LandingPage_Items/ModalxInAction_Icons/Image6.png": 7597,
	"./LandingPage_Items/ModalxInAction_Icons/Image7.png": 1444,
	"./LandingPage_Items/ModalxInAction_Icons/Image8.png": 5315,
	"./LandingPage_Items/ModalxInAction_Icons/Image_1.png": 6511,
	"./LandingPage_Items/ModalxInAction_Icons/Image_2.png": 9652,
	"./LandingPage_Items/ModalxInAction_Icons/Image_3.png": 3549,
	"./LandingPage_Items/ModalxInAction_Icons/Image_4.png": 8690,
	"./LandingPage_Items/ModalxInAction_Icons/Image_5.png": 3515,
	"./LandingPage_Items/ModalxInAction_Icons/Image_6.png": 1536,
	"./LandingPage_Items/ModalxInAction_Icons/Image_7.png": 9657,
	"./LandingPage_Items/ModalxInAction_Icons/Image_8.png": 3790,
	"./LandingPage_Items/Personalized_Img_1.png": 4414,
	"./LandingPage_Items/Personalized_Img_1_990.png": 8653,
	"./LandingPage_Items/Personalized_Img_2.png": 165,
	"./LandingPage_Items/Personalized_Img_2_990.png": 7538,
	"./LandingPage_Items/Personalized_Img_3.png": 4252,
	"./LandingPage_Items/Personalized_Img_3_990.png": 7247,
	"./LandingPage_Items/Testimonials/Avatar.png": 5610,
	"./LandingPage_Items/Testimonials/linkedin.png": 9651,
	"./LandingPage_Items/VideoGallery/videoGallery01.png": 9982,
	"./LandingPage_Items/VideoGallery/videoGallery02.png": 5733,
	"./LandingPage_Items/VideoGallery/videoGallery03.png": 2844,
	"./LandingPage_Items/VideoGallery/videoGallery04.png": 3011,
	"./LandingPage_Items/VideoGallery/videoGallery05.png": 1434,
	"./LandingPage_Items/VideoGallery/videoGallery06.png": 6097,
	"./LandingPage_Items/VideoGallery/videoGallery07.png": 6152,
	"./LandingPage_Items/VideoGallery/videoGallery08.png": 2703,
	"./LandingPage_Items/VideoGallery/videoGallery09.png": 4614,
	"./LandingPage_Items/modalx_Round_Icon_dm.png": 4094,
	"./LandingPage_Items/useCases/useCase01.png": 2401,
	"./LandingPage_Items/useCases/useCase02.png": 1290,
	"./LandingPage_Items/useCases/useCase03.png": 5395,
	"./LandingPage_Items/useCases/useCase04.png": 9148,
	"./LandingPage_Logos.png": 7043,
	"./Link_Icon.png": 1538,
	"./LinkedInIconForUserInfo.png": 2257,
	"./Marketing_Page/Post1.png": 2256,
	"./Marketing_Page/Post2.png": 587,
	"./Marketing_Page/Post3.png": 6370,
	"./Marketing_Page/Post4.png": 8877,
	"./Marketing_Page/Post5.png": 8932,
	"./Marketing_Page/Post6.png": 3583,
	"./Marketing_Page/boyImage.png": 5434,
	"./Marketing_Page/boyImageSmallScreen.png": 3537,
	"./Marketing_Page/ladyImage.png": 8812,
	"./Marketing_Page/ladyImageSmallScreen.png": 6043,
	"./ModalX_-_Black_Gradient-removebg.png": 8468,
	"./ModalX_-orange_Icon.png": 3935,
	"./ModalX_Globe.gif": 2176,
	"./ModalX_Video_Preview.mp4": 4537,
	"./ModalX_WorkFlowDiagram(900).png": 6794,
	"./ModalX_WorkFlowDiagram.png": 4130,
	"./ModalX_landingPage_Video.mp4": 2457,
	"./Modal_Logo_For_Navbar.png": 4194,
	"./Modal_X_-_B_W-removebg.png": 845,
	"./PresentationGallery/01.png": 1760,
	"./PresentationGallery/02.png": 91,
	"./PresentationGallery/03.png": 5266,
	"./PresentationGallery/04.png": 125,
	"./PresentationGallery/05.png": 6228,
	"./PresentationGallery/06.png": 3087,
	"./PresentationGallery/07.png": 6150,
	"./PresentationGallery/08.png": 3457,
	"./PresentationGallery/09.png": 3240,
	"./PresentationGallery/ModalxLogo.png": 4821,
	"./PresentationGallery/blog1.png": 1044,
	"./Safety/Image_1.png": 6328,
	"./Upload_Icon.png": 2355,
	"./companyLogo.webp": 3750,
	"./greencheckIcon.png": 4368,
	"./homeSlide1.webp": 885,
	"./homeSlide2.webp": 7832,
	"./homeSlide3.webp": 8152,
	"./homeSlide4.webp": 294,
	"./homeSlide5.webp": 6401,
	"./homeSlide6.webp": 4804,
	"./homeSlide7.webp": 8983,
	"./image1.webp": 5506,
	"./image2.webp": 3155,
	"./image3.webp": 2752,
	"./image4.webp": 7881,
	"./landingPageActionImage.png": 6889,
	"./mail.png": 7605,
	"./modalX_Dark.svg": 5482,
	"./modalX_Light.svg": 8178,
	"./modalX_robot_icon_black.png": 218,
	"./modalX_robot_icon_white.png": 5052,
	"./modalX_transparent_orange_icon.png": 7593,
	"./modalX_twin.svg": 3316,
	"./modalx_logo_for_landingpage_dm.png": 2310,
	"./plusIcon_for_new_project.png": 6174,
	"./ppt_template_1.png": 8533,
	"./ppt_template_2.png": 6734,
	"./ppt_template_3.png": 9751,
	"./ppt_template_4.png": 8232,
	"./ppt_template_5.png": 2849,
	"./ppt_template_6.png": 3866,
	"./shareIcon.png": 9204,
	"./signup/Frame 142.png": 2745,
	"./signup/Group 174.png": 1508,
	"./signup/error.png": 2531,
	"./signup/mail.png": 1532,
	"./signup/ppt1.png": 1380,
	"./signup/ppt2.png": 2223,
	"./signup/ppt3.png": 3206,
	"./signup/success.png": 2851,
	"./transparent-google-logo-google-logo-with-multicolored-g-and-1710875781697.png": 7991,
	"./upgradeLogo.png": 2535,
	"./—Pngtree—facebook social media icon facebook_3654772.png": 804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;